import { defineMessages } from 'react-intl';

export default defineMessages({

  tripCancellation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.tripCancellation',
    defaultMessage: 'Are you claiming for Trip Cancellation?',
  },

  reasonsForTripCancellation: {
    id: 'fastCover.tripCancellationCFStep.reasonsForTripCancellation',
    defaultMessage: 'Reasons for Trip Cancellation',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },

  travelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.travelInterruption',
    defaultMessage: 'Are you claiming for Trip Interruption?',
  },

  // travelDelay: {
  //   id: 'fastCover.stepTripCancellationAndTripInterruption.travelDelay',
  //   defaultMessage: 'Are you claiming for Travel Delay?',
  // },

  reasonsForTripInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },

  reasons1: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons1',
    defaultMessage: 'Death of Insured, Traveling Companion, or Family member (traveling or non-traveling)',
  },

  reasons2: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons2',
    defaultMessage: 'Sickness or Accidental Injury of insured, Traveling Companion, or Family Member (traveling or non-traveling)',
  },

  reasons3: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons3',
    defaultMessage: 'Death or Hospitalization of the Host at Destination',
  },

  reasons4: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons4',
    defaultMessage: 'Termination or lay-off',
  },

  reasons5: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons5',
    defaultMessage: 'Transfer of employment',
  },

  reasons6: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons6',
    defaultMessage: 'Emergency duty recall',
  },

  reasons7: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons7',
    defaultMessage: 'Weather related cessation of services of Common carrier',
  },

  reasons8: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons8',
    defaultMessage: 'Uninhabitable accommodations',
  },

  reasons9: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons9',
    defaultMessage: 'Terrorist Incident',
  },
  reasons10: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons10',
    defaultMessage: 'You or Your Traveling Companion are a victim of a felonious assault',
  },

  reasons11: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons11',
    defaultMessage: 'Hijack, Quarantine, Jury duty, or subpoena, Uninhabitable Home',
  },

  reasons12: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons12',
    defaultMessage: 'Directly involved in a traffic accident ',
  },

  reasons13: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons13',
    defaultMessage: 'Bankruptcy or Default of a Travel Supplier',
  },

  reasons14: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons14',
    defaultMessage: 'Strike causing cessation of services of the Common Carrier',
  },

  reasons15: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons15',
    defaultMessage: 'Other',
  },

  companyNameTravelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.companyNameTravelInterruption',
    defaultMessage: 'Company Name',
  },

  addressTravelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addressTravelInterruption',
    defaultMessage: 'Address',
  },

  cityTravelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.cityTravelInterruption',
    defaultMessage: 'City',
  },

  stateTravelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.stateTravelInterruption',
    defaultMessage: 'State',
  },

  zipCodeTravelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },

  contactTravelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.contactTravelInterruption',
    defaultMessage: 'Contact',
  },

  phoneNumberTravelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.phoneNumberTravelInterruption',
    defaultMessage: 'Phone Number',
  },

  includedInPackage: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },

  lossInformation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.lossInformation',
    defaultMessage: 'Loss Information',
  },

  lossInformationPerPerson: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.lossInformationPerPerson',
    defaultMessage: 'Loss Information',
  },

  addLossInformation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },

  dateTripInterrupted: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateTripInterrupted',
    defaultMessage: 'Date Trip was Interrupted',
  },

  lossInformationWithIdx: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  reasonForInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasonForInterruption',
    defaultMessage: 'Other reasons for interruption',
  },

  nameOfPersonHavingSickness: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness of injury',
  },

  dateOfBirth: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },

  relationshipToClaimant: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },

  dateSicknessOrInjuryBegan: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness Or Injury began',
  },

  dateEnded: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateEnded',
    defaultMessage: 'Date ended',
  },

  natureOfSicknessOrInjury: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },

  periodOfHospitalization: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.periodOfHospitalization',
    defaultMessage: 'Period of hospitalization (If applicable)',
  },

  companyNameLoss: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruise/travel agent/etc.)',
  },

  amountPaidLoss: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.amountPaidLoss',
    defaultMessage: 'Amount Paid (total for all insureds)',
  },

  amountOfLoss: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  amountClaimed: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  fromWhom: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.fromWhom',
    defaultMessage: 'If so, from whom?',
  },

  reasonsForDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasonsForDelay',
    defaultMessage: 'Reasons for Delay',
  },

  reasons1ForTravelDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons1ForTravelDelay',
    defaultMessage: 'Delay of a Common Carrier (including Inclement Weather)',
  },

  reasons2ForTravelDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons2ForTravelDelay',
    defaultMessage: 'Delay by a traffic Accident enroute to a departure, in which You or Your Traveling Companion is not directly involved',
  },

  reasons3ForTravelDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons3ForTravelDelay',
    defaultMessage: 'Delay due to lost or stolen passport, travel documents or money, Quarantine, hijacking, unannounced Strike, Natural Disaster, civil commotion, or riot',
  },

  reasons4ForTravelDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons4ForTravelDelay',
    defaultMessage: 'A closed roadway causing cessation of travel to the destination of the Trip (substantiated by the department of transportation, state police, etc.)',
  },

  dateOfInitialPaymentDeposit: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateOfInitialPaymentDeposit',
    defaultMessage: 'Date of initial payment deposit',
  },

  dateYouWereDueToDepart: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },

  timeYouWereDueToDepart: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },

  dateTripWasDelayed: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateTripWasDelayed',
    defaultMessage: 'Date trip was delayed with Travel Supplier',
  },

  dateDelayEnded: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateDelayEnded',
    defaultMessage: 'Date delay ended',
  },

  dateYouActuallyDeparted: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },

  timeYouActuallyDeparted: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },

  delayInformation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayInformation',
    defaultMessage: 'Delay Information',
  },

  addDelayInformation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addDelayInformation',
    defaultMessage: 'Add Delay Information',
  },

  delayInformationWithIdx: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },
  dateReimbursementReceived: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },

  yes: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.no',
    defaultMessage: 'No',
  },
  fromDate: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.fromDate',
    defaultMessage: 'From Date',
  },
  toDate: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.toDate',
    defaultMessage: 'To Date',
  },

  //-----------------------------------------------------------------------------------------

  howItHappened: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delay',
    defaultMessage: 'Delay',
  },
  whoDidYouReportThisTo: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.whoDidYouReportThisTo',
    defaultMessage: 'Who did you report this to?',
  },
  police: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.other',
    defaultMessage: 'Other',
  },
  notReported: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.notReported',
    defaultMessage: 'Not Reported',
  },
  otherDescription: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.otherDescription',
    defaultMessage: 'If other, please describe',
  },
  reportReferenceNumber: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },
  descriptionOfItem: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  currency: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.currency',
    defaultMessage: 'Currency',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  item: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.item',
    defaultMessage: 'Item',
  },
  claimed: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  other1: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.other1',
    defaultMessage: 'Proof of loss (i.e. police report, report to hotel, airline, transport provider)',
  },
  other2: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.other2',
    defaultMessage: 'Proof of ownership/receipts/bank statements for each item',
  },
  other3: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.other3',
    defaultMessage: 'Written confirmation of an IMEI block from your network provider',
  },
  other4: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.other4',
    defaultMessage: 'A damage/repair report or quotation',
  },
  other5: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.other5',
    defaultMessage: 'Written confirmation of luggage delay',
  },
  other6: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.other6',
    defaultMessage: 'Receipts, bank statements and/or proof of payment for each expense being claimed',
  },
  itemWithIdx: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.itemWithIdx',
    defaultMessage: 'Item {idx}',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  checkEventDate: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
  detailsRegardingYourTripDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.detailsRegardingYourTripDelay',
    defaultMessage: 'Details regarding your Trip Delay',
  },
  dateTripWasDelayedWithTravelSupplier: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateTripWasDelayedWithTravelSupplier',
    defaultMessage: 'Date Trip was delayed with Travel Supplier',
  },
  dateOfExpenses: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateOfExpenses',
    defaultMessage: 'Date Of Expenses',
  },
  areYouCancellingTheTripDueToMedicalReasons: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.areYouCancellingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you cancelling the trip due to medical reasons?',
  },
  insureds: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addInsured',
    defaultMessage: 'Name(s) and birth dates of all claimants:',
  },
  travelSupplier: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },
  dateTripWasCancelledWithTravelSupplier: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateTripWasCancelledWithTravelSupplier',
    defaultMessage: 'Date Trip was cancelled with Travel Supplier',
  },
  reasonForCancellation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasonForCancellation',
    defaultMessage: 'Other reasons for cancellation',
  },
  tripCancellationForAnyReason: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.tripCancellationForAnyReason',
    defaultMessage: 'Are you claiming Trip Cancellation for Any Reason?',
  },
  addInsured: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addInsured',
    defaultMessage: 'Add Insured',
  },
  birthDay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.birthDay',
    defaultMessage: 'Birth Day',
  },
  fullName: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.fullName',
    defaultMessage: 'Full Name',
  },
  insuredInformationWithIdx: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.insuredInformationWithIdx',
    defaultMessage: 'Insured Information {idx}',
  },
  areYouInterruptingTheTripDueToMedicalReasons: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.areYouInterruptingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you interrupting the trip due to medical reasons?',
  },
  travelSupplierWithIdx: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.travelSupplierWithIdx',
    defaultMessage: 'Travel Supplier Information {idx}',
  },
  addSupplier: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addSupplier',
    defaultMessage: 'Add Supplier',
  },
  expenseFor: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.expenseFor',
    defaultMessage: 'Expense For',
  },
  selectInsuredForExpense: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.selectInsuredForExpense',
    defaultMessage: 'Select the Insured(s) for the expense',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepTripCancellationAndTripInterruption/messages.js